module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15ari8v/CoverDesign.jpg?1684274498317",
      "alt": "This image is the cover for the book Aimer, éperdument"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Aimer, éperdument\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Trois ans d’infiltration dans l’un des pires gangs du pays ont laissé l’agent du FBI, Joshua Chastain, complètement bouleversé. Luttant contre les cauchemars et l’addiction, il quitte la jungle bétonnée pour le Nouveau-Mexique, le pays des chevaux, en espérant recommencer à zéro dans le ranch de son oncle.")]), _vm._v(" "), _c('p', [_vm._v("Le contremaître Eli Kelly passe sa vie à réhabiliter des animaux maltraités, et Joshua est juste une autre âme perdue. Mais quand Joshua commence doucement à reconstruire sa vie, Eli réalise que Joshua représente beaucoup plus qu’un nouveau projet.")]), _vm._v(" "), _c('p', [_vm._v("Le plan de Joshua semble fonctionner – peut-être qu’un nouveau départ était exactement ce dont il avait besoin. Puis, au moment où il commence à peine à trouver un semblant de paix, le crime et la haine détruisent presque tout ce pour quoi il a travaillé, le forçant à réévaluer ce qu’il veut vraiment faire ressortir de sa relation avec Eli et de sa propre vie.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rowan Speedwell, J.N.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0